import { BroadcastChannel } from "broadcast-channel";

export const createChannel = (channelName: string) =>
  new BroadcastChannel(channelName);
